/* eslint-disable n/no-process-env */

// This is the only file where process.env are accessed and then re-used on the app, this is the way to see errors on the app more clearly if a env is missing
const getEnvs = () => {
  try {
    return {
      REACT_APP_ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
      REACT_APP_MATOMO_URL: process.env.REACT_APP_MATOMO_URL,
      NODE_ENV: process.env.NODE_ENV || 'development',
      REACT_APP_MATOMO_SITE_ID: process.env.REACT_APP_MATOMO_SITE_ID,
      REACT_APP_API_MOCKING: process.env.REACT_APP_API_MOCKING,
      // ESLINT_NO_DEV_ERRORS: process.env.ESLINT_NO_DEV_ERRORS,
      // DISABLE_ESLINT_PLUGIN: process.env.DISABLE_ESLINT_PLUGIN,
      PUBLIC_URL: '/',
      REACT_APP_COVALO_STATIC_CONTENT:
        process.env.REACT_APP_COVALO_STATIC_CONTENT,
      REACT_APP_COVALO_API: process.env.REACT_APP_COVALO_API,
      REACT_APP_KEYCLOAK_CLIENT: process.env.REACT_APP_KEYCLOAK_CLIENT,
      REACT_APP_KEYCLOAK_REALM: process.env.REACT_APP_KEYCLOAK_REALM,
      REACT_APP_KEYCLOAK_URL: process.env.REACT_APP_KEYCLOAK_URL,
      REACT_APP_COVALO_API_SEARCH: process.env.REACT_APP_COVALO_API_SEARCH,
      REACT_APP_COVALO_LEGACY_API: process.env.REACT_APP_COVALO_LEGACY_API,
      REACT_APP_COVALO_HOST: process.env.REACT_APP_COVALO_HOST,
      REACT_APP_COVALO_FRONTOFFICE: process.env.REACT_APP_COVALO_FRONTOFFICE,
      REACT_APP_LAUNCH_DARKLY_ID: process.env.REACT_APP_LAUNCH_DARKLY_ID,
      // REACT_APP_THEME_VERSION:
      //   process.env.REACT_APP_THEME_VERSION || 'unknown-version',
      REACT_APP_HUBSPOT_URL: process.env.REACT_APP_HUBSPOT_URL,
      REACT_APP_INCOS_EVENTS: process.env.REACT_APP_INCOS_EVENTS,
      REACT_APP_BRANDPORTAL_COLUMN_CONFIGURATIONS:
        process.env.REACT_APP_BRANDPORTAL_COLUMN_CONFIGURATIONS,
      REACT_APP_COVALO_WHITELABEL_EVENT_KEY:
        process.env.REACT_APP_COVALO_WHITELABEL_EVENT_KEY,
      REACT_APP_WHITELABEL_COMPANY_KEY:
        process.env.REACT_APP_WHITELABEL_COMPANY_KEY,
      REACT_APP_SENTRY_ENVIRONMENT: process.env.REACT_APP_SENTRY_ENVIRONMENT,
      REACT_APP_UXBEAUTY: process.env.REACT_APP_UXBEAUTY || ''
    };
  } catch (e) {
    throw new Error('Error while reading the envs: ' + e);
  }
};

export const envs = { ...getEnvs() };